import ModalBase from "components/shared/ModalBase";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface IDownloadFilesModal {
    open: boolean;
    onClose: () => void;
    /**
     * Selected rows table count (items)
     */
    selectedItemsCount: number;
    /**
     * Handle download
     */
    handleDownload: () => void;
    /**
     * Modal Title
     */
    modalTitle: string;
}
/**
 * Render download items confirmation modal after selected table rows
 */
const DownloadFilesModal = ({ open, onClose, selectedItemsCount, handleDownload, modalTitle }: IDownloadFilesModal) => {
    const [t] = useTranslation();
    return (
        <ModalBase open={open} onClose={onClose} modalTitle={modalTitle}>
            <div className={styles["download-files-modal"]}>
                <div className={styles["dowload-info"]}>
                    <p>
                        {t("Management.YouSelect")}{" "}
                        <b>
                            {selectedItemsCount} {t("Management.Elements")}
                        </b>
                        . {t("Management.WantDownload")}
                    </p>
                    <p>{t("Management.ReceiveLink")}</p>
                </div>
                <div className={styles["download-controls"]}>
                    <StyledButton buttonType="secondary" onClick={onClose} fullWidth>
                        {t("Management.NoCancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={handleDownload} fullWidth>
                        {t("Management.YesDownload")}
                    </StyledButton>
                </div>
            </div>
        </ModalBase>
    );
};

export default DownloadFilesModal;
